import { render, staticRenderFns } from "./news-all.vue?vue&type=template&id=8a369b64&scoped=true&"
import script from "./news-all.vue?vue&type=script&lang=js&"
export * from "./news-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a369b64",
  null
  
)

export default component.exports